import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Loading from "../helpers/loading_component.js";
import "../styles/payments.css";
import { secretKey } from "../.././data";
import EditPelnSub from "./editPelnSub.js";

const MySwal = withReactContent(Swal2);

const AddFile = (props) => {
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadFiles, setUploadFiles] = useState("");
  const [uploadFilesArray, setUploadFilesArray] = useState([]);
  const [uploadFilesNamesArray, setUploadFilesNamesArray] = useState([]);
  const [uploadFilesNamesArrayChanged, setUploadFilesNamesArrayChanged] =
    useState([]);
  const [inputs, setInputs] = useState({});
  const [fileType, setFileType] = useState("send");

  const changeFiles = (e) => {
    setUploadFiles([]);
    setUploadFilesArray([]);
    setUploadFilesNamesArray([]);

    var check = false;

    Array.from(e.target.files).map((file) => {
      if (file.size > 41943040) {
        MySwal.fire({
          icon: "error",
          title: "Błąd",
          text: "plik przekracza 40MB",
        });
        check = true;
      }
    });

    if (check) {
      return;
    }

    setUploadFiles(e.target.files);
    setUploadFilesArray(Array.from(e.target.files));
    var arr = [];
    Array.from(e.target.files).map((el, index) => {
      arr.push({ id: index, name: el.name });
    });
    setUploadFilesNamesArray(arr);
  };

  const changeFileName = (e) => {
    if (inputs[e.target.value] === "" || inputs[e.target.value] === undefined) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    } else {
      var name = inputs[e.target.value];
      var newFile = new File(
        [uploadFilesArray[e.target.value]],
        name + "." + uploadFilesArray[e.target.value].name.split(".")[1],
        {
          type: uploadFilesArray[e.target.value].type,
        }
      );

      var arr = uploadFilesArray.filter(
        (el, index) => index !== +e.target.value
      );
      arr.push(newFile);

      setUploadFilesArray(arr);
      inputs[e.target.value] = "";
    }
  };

  const deleteTempFile = (e) => {
    var arr = uploadFilesArray.filter((el, index) => index !== +e.target.value);

    setUploadFilesArray(arr);
  };

  const sendFiles = async (e) => {
    var length = uploadFilesArray.length;
    var progr = 0;
    uploadFilesArray.map(async (file) => {
      let formData = new FormData();
      formData.append("file", file);
      formData.append(
        "type",
        props.place === "sub"
          ? "other"
          : props.place === "task"
          ? "task"
          : fileType
      );
      formData.append("clientId", props.id);
      formData.append("taskId", props.place === "task" ? props.taskId : "");
      formData.append("user", props.user);

      await fetch("https://apidevkppp.ftpeople.pl/uploadFile", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.text();
        })
        .then((responseJson) => {
          ++progr;

          MySwal.fire({
            icon: "success",
            title: "Wysłano plik: " + progr + "/" + length,
            text: "",
          }).then((result) => {
            if (progr === length) {
              if (props.place === "sub") {
                props.logClientAction(
                  "Edytowano informację o pełnomocniku substytucyjnym",
                  props.id
                );
                MySwal.fire({
                  icon: "success",
                  title: "Edytowano",
                  text: "sprawę",
                }).then(async (result) => {
                  props.close();
                });
              } else if (props.place === "task") {
                MySwal.fire({
                  title: "Czy chcesz dodać pełnomocnika substytucyjnego?",
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "Tak",
                  denyButtonText: `Nie`,
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    setShowEditPelnSub(true);
                  } else if (result.isDenied) {
                    MySwal.fire({
                      icon: "success",
                      title: "Edytowano",
                      text: "sprawę",
                    }).then(async (result) => {
                      props.close();
                    });
                  }
                });
              } else {
                MySwal.fire({
                  icon: "success",
                  title: "Dodano",
                  text: "pliki",
                }).then((result) => {
                  props.logClientAction("Dodano pliki do sprawy", props.id);
                  setUploadFiles([]);
                  setUploadFilesArray([]);
                  props.close();
                });
              }
            }
          });
        });
    });
  };

  const closeEditPelnSub = (e) => {
    setShowEditPelnSub(false);
    MySwal.fire({
      icon: "success",
      title: "Edytowano",
      text: "sprawę",
    }).then(async (result) => {
      props.close();
    });
  };

  return (
    <>
      {showEditPelnSub ? (
        <EditPelnSub
          close={closeEditPelnSub}
          refreshData={props.refreshData}
          clientsData={props.client}
          clientsSheetData={props.clientsSheetData}
          logClientAction={props.logClientAction}
          client={props.client}
          userName={props.user}
          mode="task"
        />
      ) : (
        ""
      )}
      <div
        style={
          props.peln === "1"
            ? {
                width: "50vw",
                position: "fixed",
                height: "30vh",
                zIndex: "999",
              }
            : { width: "50vw", position: "fixed", zIndex: "999" }
        }
        className="mainContainerAddTransaction"
      >
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button
                className="closeClientButton"
                onClick={
                  props.place === "sub" ? props.closeNoFile : props.close
                }
              >
                X
              </button>
            </div>
            <>
              <input multiple={true} type="file" onChange={changeFiles} />
              {props.place === "main" ? (
                <>
                  <div
                    style={{ marginTop: "0", marginBottom: "5vh" }}
                    className="inputBox"
                  >
                    <div className="inputCol_2">
                      <label>Kategoria plików</label>
                      <select
                        style={{ height: "3vh" }}
                        type="text"
                        id="court"
                        name="court"
                        value={fileType}
                        onChange={(e) => setFileType(e.target.value)}
                      >
                        <option key={0} value="co-op">
                          Dokumenty do współpracy z kancelarią
                        </option>
                        <option key={1} value="credit">
                          Dokumenty kredytowe
                        </option>
                        <option key={2} value="court">
                          Pisma z sądu
                        </option>
                        <option key={6} value="bank">
                          Pisma z banku
                        </option>
                        <option key={3} value="send">
                          Pisma wysłane do sprawy
                        </option>
                        <option key={4} value="other">
                          Inne
                        </option>
                        <option key={5} value="segr">
                          Zeskanowany segregator fizyczny
                        </option>
                      </select>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <>
                {uploadFilesArray.length > 0 ? (
                  <>
                    <div style={{ maxHeight: "35vh", overflowY: "scroll" }}>
                      <table
                        style={{ width: "100%", boxSizing: "border-box" }}
                        id="detailClientTable"
                        className="clients_table"
                      >
                        <tr>
                          <th>Nazwa pliku</th>
                          <th>Plik</th>
                          <th></th>
                        </tr>
                        {uploadFilesArray.length > 0
                          ? uploadFilesArray.map((el, index) => (
                              <>
                                <tr>
                                  <td
                                    style={{
                                      width: "50%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <div
                                      style={{ display: "flex", gap: "10px" }}
                                    >
                                      <input
                                        id={"fn" + index}
                                        name={"fn" + index}
                                        style={{
                                          height: "2vh",
                                          marginTop: "0",
                                        }}
                                        type="text"
                                        value={inputs[index]}
                                        onChange={(e) =>
                                          setInputs((prev) => {
                                            return {
                                              ...prev,
                                              [index]: e.target.value,
                                            };
                                          })
                                        }
                                      />
                                      <button
                                        className="refreshButton"
                                        value={index}
                                        onClick={changeFileName}
                                      >
                                        zmień
                                      </button>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "40%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                      wordWrap: "anywhere",
                                    }}
                                  >
                                    {el.name}
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      width: "10%",
                                      padding: "5px 20px",
                                      height: "3vh",
                                    }}
                                  >
                                    <button
                                      className="refreshButton"
                                      value={index}
                                      onClick={deleteTempFile}
                                    >
                                      usuń
                                    </button>
                                  </td>
                                </tr>
                              </>
                            ))
                          : ""}
                      </table>
                    </div>
                    <div style={{ marginTop: "2vh" }}>
                      <button
                        style={{ width: "15%" }}
                        className="refreshButton"
                        onClick={sendFiles}
                      >
                        Wyślij
                      </button>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default AddFile;
